<template>
  <el-card>
    <el-form class="global-add-form" ref="form" label-width="100px" label-position="right">
      <el-form-item label="所属公园" prop="projectId">
        <p>{{ detail.projectName || '' }}</p>
      </el-form-item>
      <el-form-item label="游客手机号" prop="mobile">
        <p>{{ detail.mobile || '' }}</p>
      </el-form-item>
      <el-form-item label="反馈内容" prop="feedbackContent">
        <p>{{ detail.feedbackContent || '' }}</p>
      </el-form-item>
      <el-form-item label="反馈照片" prop="fileList">
        <template v-if="detail.fileList.length">
          <custom-upload v-model="detail.fileList" disabled></custom-upload>
        </template>
      </el-form-item>
      <el-form-item label="反馈时间" prop="ctime">
        <p>{{ detail.ctime || '' }}</p>
      </el-form-item>
      <el-form-item label="状态" prop="state">
        <p>{{ detail.state === 1 ? '待回复' : '已回复' }}</p>
      </el-form-item>
      <template v-if="detail.state === 2">
        <el-form-item label="回复内容" prop="recoveryContent">
          <p>{{ detail.recoveryContent || '' }}</p>
        </el-form-item>
        <el-form-item label="回复时间 " prop="recoveryTime">
          <p>{{ detail.recoveryTime || '' }}</p>
        </el-form-item>
      </template>
      <el-form-item v-if="detail.state === 1">
        <el-button type="primary" @click="onFeed" v-if="$ButtonShow('AUF_EDT_01')">回复游客</el-button>
      </el-form-item>
    </el-form>
    <reply-dialog v-if="showReply" @reLoad="loadData" :showReply.sync="showReply"
      :feedbackId="feedbackId"></reply-dialog>
  </el-card>
</template>

<script>
import ReplyDialog from './ReplyDialog'
export default {
  name: 'FeedbackDetail',
  components: {
    ReplyDialog
  },
  data() {
    return {
      showReply: false,
      detail: {
        projectName: '',
        mobile: '',
        recoveryContent: '',
        fileList: [],
        state: '',
        recoveryTime: ''
      }
    }
  },
  computed: {
    feedbackId() {
      return this.$route.params.feedbackId
    }
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.tourist.selectAppUserFeedbackByFeedbackId, {
        feedbackId: this.feedbackId
      }).then(res => {
        this.detail = res || {}
      })
    },
    onFeed() {
      this.showReply = true
    }
  }
}
</script>

<style scoped></style>
